module.exports = __webpack_public_path__ + "static/avatar-borders-dont-c8649ca7d334d263c93ec3007910382b.png";